import styled from 'styled-components';

export const Std = styled.div`
  position: fixed;
  inset: 0px;
  background-color: ${props => props.$back};
  transition: opacity 300ms ease 0s;
  opacity: ${props => props.$op ?? 1};
  z-index: ${props => props.$z};
`;


